import { request } from "utils/request";
import { AxiosPromise } from "axios";


export const newsApi = {
    findAll: (params?: any): AxiosPromise<any> => request({
        url: '/v1/admin/news',
        params
    }),
    create: (data: any): AxiosPromise<any> => request({
        url: '/v1/admin/news',
        data,
        method: 'post'
    }),
    update: (id: number, data: any): AxiosPromise<any> => request({
        url: `/v1/admin/news/${id}`,
        method: 'patch',
        data
    }),
    upload: (data: any): AxiosPromise<any> => request({
        url: `/v1/admin/news/upload`,
        method: 'post',
        data
    }),
    delete: (id: number): AxiosPromise<any> => request({
        url: `/v1/admin/news/${id}`,
        method: 'delete'
    }),
}
